import Image, { getImageProps } from 'next/image';
import { createUploadcareImageComponent } from '@pkgs/components';

import { customImageLoader } from '@/utils/imageLoader';

export const ImageComponent = createUploadcareImageComponent({
  baseLoader: customImageLoader,
  getImageProps: (props) => getImageProps(props),
  imageComponent: Image,
});
